module.exports = __webpack_public_path__ + "static/5-54c821fb4d3aec2b568424af5e551040.jpg";